module.exports = __webpack_public_path__ + "static/media/security-lock.870fe701.svg";